import { uniqueNamesGenerator } from "unique-names-generator";
import { useContext, useEffect } from "react";
import { Context } from "../../provider/index.js";

export const generateName = () => {
  const flora = [
    "Cedar",
    "Willow",
    "Maple",
    "Pine",
    "Ash",
    "Birch",
    "Hawthorn",
    "Oak",
    "Alder",
    "Hazel",
    "Spruce",
    "Juniper",
    "Fir",
    "Elm",
    "Cherry",
    "Olive",
    "Magnolia",
    "Walnut",
    "Aspen",
    "Yew",
    "Bamboo",
    "Palm",
    "Rose",
    "Lily",
    "Daisy",
    "Violet",
    "Orchid",
    "Tulip",
    "Sunflower",
    "Poppy",
    "Ivy",
    "Jasmine",
    "Lavender",
    "Peony",
    "Lotus",
    "Marigold",
    "Myrtle",
    "Fern",
    "Cactus",
    "Moss",
    "Mint",
    "Thistle",
    "Clover",
    "Sage",
    "Rosemary",
    "Thyme",
    "Basil",
    "Bay",
    "Cyclamen",
    "Begonia",
  ];

  const weathers = [
    "Sunny",
    "Stormy",
    "Cloudy",
    "Windy",
    "Rainy",
    "Foggy",
    "Snowy",
    "Frosty",
    "Misty",
    "Dry",
    "Icy",
    "Hazy",
    "Chilly",
    "Breezy",
    "Blustery",
    "Thunder",
    "Lightning",
    "Overcast",
    "Drizzle",
    "Sleet",
    "Blizzard",
    "Flurry",
    "Heatwave",
    "Cold",
    "Warm",
    "Cool",
    "Tropical",
    "Freezing",
    "Boiling",
    "Glacial",
    "Scorching",
    "Brisk",
    "Mild",
    "Harsh",
    "Crisp",
    "Balmy",
    "Stifling",
    "Sweltering",
    "Frigid",
    "Temperate",
  ];

  const shortName = uniqueNamesGenerator({
    dictionaries: [weathers, flora],
    length: 2,
    separator: " ",
  });

  return shortName;
};

export const NameGenerator = () => {
  const { dispatch } = useContext(Context);

  useEffect(() => {
    const storedShortName = localStorage.getItem("shortName");
    if (storedShortName) {
      dispatch({ type: "randomName", payload: storedShortName });
    } else {
      const newName = generateName();
      localStorage.setItem("shortName", newName);
      dispatch({ type: "randomName", payload: newName });
    }
  }, [dispatch]);

  return null;
};
